(ns practitest.frontend.components2.horizontal-scroll-strip
  (:require
    [reagent.core :as reagent]
    [reagent.dom :as rdom]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.buttons :as buttons]))

(defn horizontal-scroll-strip
  "Horizontally scrollable strip with left/right arrow buttons.

   Props (first arg map):
     :active-key      - changes when the active item changes; triggers scroll-to-active on update
     :active-selector - CSS selector for the active element (default: \".tab.active\")
     :scroll-amount   - pixels scrolled per button click (default: 150)
     :class           - extra CSS class on the outer .h-scroll-strip div

   Remaining args are rendered as children inside the scroll area."
  [_props & _children]
  (let [can-left?    (reagent/atom false)
        can-right?   (reagent/atom false)
        area-ref     (atom nil)
        observer-ref (atom nil)

        sync-state!
        (fn []
          (when-let [area @area-ref]
            (reset! can-left?  (> (.-scrollLeft area) 2))
            (reset! can-right? (< (+ (.-scrollLeft area) (.-clientWidth area))
                                   (- (.-scrollWidth area) 2)))))

        scroll-by!
        (fn [delta]
          (when-let [area @area-ref]
            (.scrollBy area #js {:left delta :behavior "smooth"})
            (js/setTimeout sync-state! 300)))

        scroll-to-active!
        (fn [selector]
          (when-let [area @area-ref]
            (when-let [active-el (.querySelector area selector)]
              (.scrollIntoView active-el #js {:block "nearest" :inline "nearest"})))
          (sync-state!))]

    (reagent/create-class
      {:display-name "horizontal-scroll-strip"

       :component-did-mount
       (fn [this]
         (let [node     (rdom/dom-node this)
               area     (.querySelector node ".h-scroll-area")
               selector (or (:active-selector (second (reagent/argv this))) ".tab.active")]
           (reset! area-ref area)
           (.addEventListener area "scroll" sync-state!)
           (let [obs (js/ResizeObserver. (fn [] (sync-state!)))]
             (.observe obs area)
             (reset! observer-ref obs))
           ; Defer via fonts.ready + rAF so layout is settled with correct font metrics before scrolling
           (.then (.. js/document -fonts -ready)
                  (fn [_]
                    (js/requestAnimationFrame (fn [_] (scroll-to-active! selector)))))))

       :component-did-update
       (fn [this old-argv]
         (let [props    (second (reagent/argv this))
               selector (or (:active-selector props) ".tab.active")]
           (when (not= (:active-key (second old-argv)) (:active-key props))
             (scroll-to-active! selector))
           (sync-state!)))

       :component-will-unmount
       (fn []
         (when-let [obs @observer-ref] (.disconnect obs))
         (when-let [area @area-ref]
           (.removeEventListener area "scroll" sync-state!)))

       :reagent-render
       (fn [props & children]
         [:div.h-scroll-strip {:class (:class props)}
          (into [:div.h-scroll-area] children)
          [:div.h-scroll-btns
           [buttons/icon-button
            {:class     "h-scroll-btn"
             :disabled? (not @can-left?)
             :on-click  #(scroll-by! (- (or (:scroll-amount props) 180)))
             :icon      [icons/mux-chevron-left]}]
           [buttons/icon-button
            {:class     "h-scroll-btn"
             :disabled? (not @can-right?)
             :on-click  #(scroll-by! (or (:scroll-amount props) 180))
             :icon      [icons/mux-chevron-right]}]]])})))
